import graphqlClient from '../../api/axios_interceptor';
import { GRAPHQL_API } from '../../api/graphql/endpoint';

import {
    FETCH_BANK_ACCOUNTS, ADD_BANK_ACCOUNT, UPDATE_BANK_ACCOUNT,
    DELETE_BANK_ACCOUNTS, FETCH_STATEMENT_BANK_ACCOUNT
} from '../actions/actionTypes';
import {
    fetchBankAccountStatementQuery,
    getBankAccountsQuery,
    addBankAccountMutation,
    updateBankAccountMutation,
    deleteBankAccountMutation
} from "../../api/graphql/queries/bankAccount";
import { updateActionErrors } from './updateErrors';

export const parseBankAccount = (account) => ({
    accountId: account.id,
    accountNumber: account.accountNumber,
    bankName: account.bankName,
    nickName: account.nickName,
    consumerSecret: account.consumerSecret,
    apiKey: account.apiKey,
    merchantCode: account.merchantCode,
    publicKey: account.publicKey,
    callbackUrl: account.callbackUrl,
    currentBalance: account.currentBalance,
    lastFullStatementCheckTs: account.lastFullStatementCheckTs
})


const fetchBankAccountMiddleware = async (action) => {
    try{
        let bankAccounts = {};
        await graphqlClient({
            data: {
                query: getBankAccountsQuery()
            },
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);

            } else {
                bankAccounts = queryResult.data.data.bankAccounts.map(parseBankAccount);
                action = ({
                    ...action,
                    payload: {
                        ...action.payload,
                        bankAccounts
                    }
                });
            }
        });
    } catch(error){
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

const addBankAccountMiddleware = async (action) => {
    try {
        const payload = action.payload;
        let query = addBankAccountMutation(payload);
        await graphqlClient({
            data: {
                query
            },
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            } else if (queryResult.data.data.addBankAccount.errors) {
                action = updateActionErrors(action, queryResult.data.data.addBankAccount.errors);
            } else {
                action = ({
                    ...action,
                    payload: {
                        ...action.payload,
                        bankAccount: parseBankAccount(queryResult.data.data.addBankAccount.bankAccount)
                    }
                });
            }
        });
    } catch (error) {
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

const updateBankAccountMiddleware = async (action) => {
    try {
        const payload = action.payload;
        let query = updateBankAccountMutation(payload.accountId, payload);
        await graphqlClient({
            data: {
                query
            },
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            } else if (queryResult.data.data.updateBankAccount.errors) {
                action = updateActionErrors(action, queryResult.data.data.updateBankAccount.errors);
            } else {
                action = ({
                    ...action,
                    payload: {
                        ...action.payload,
                        bankAccount: parseBankAccount(queryResult.data.data.updateBankAccount.bankAccount)
                    }
                });
            }
        });
    } catch (error) {
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

const deleteBankAccountMiddleware = async (action) => {
    try {
        const payload = action.payload;
        let query = deleteBankAccountMutation(payload.accountIds);
        await graphqlClient({
            data: {
                query
            },
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            } else if (queryResult.data.data.deleteBankAccount.errors) {
                action = updateActionErrors(action, queryResult.data.data.deleteBankAccount.errors);
            } else {
                action = ({
                    ...action,
                    payload: {
                        ...action.payload,
                    }
                });
            }
        });
    } catch (error) {
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

const fetchStatementBankAccountMiddleware = async (action) => {
    try{
        const payload = action.payload;
        let query = fetchBankAccountStatementQuery(payload.accountIds);
        await graphqlClient({
            data: {
                query
            },
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            } else if (queryResult.data.data.fetchAccountStatements.errors) {
                action = updateActionErrors(action, queryResult.data.data.fetchAccountStatements.errors);
            } else {
                const bankAccounts = queryResult.data.data.fetchAccountStatements.bankAccounts.map(parseBankAccount);
                action = ({
                    ...action,
                    payload: {
                        ...action.payload,
                        bankAccounts
                    }
                });
            }
        });
    } catch(error){
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

export const bankAccountsMiddleware = storeAPI => next => async action => {
    switch (action.type) {
        case FETCH_BANK_ACCOUNTS:
            action = await fetchBankAccountMiddleware(action);
            break;
        case ADD_BANK_ACCOUNT:
            action = await addBankAccountMiddleware(action);
            break;
        case UPDATE_BANK_ACCOUNT:
            action = await updateBankAccountMiddleware(action);
            break;
        case DELETE_BANK_ACCOUNTS:
            action = await deleteBankAccountMiddleware(action);
            break;
        case FETCH_STATEMENT_BANK_ACCOUNT:
            action = await fetchStatementBankAccountMiddleware(action);
            break;
    }
    return next(action);
}